import type { OrderByDirection } from '@angular/fire/firestore';
import type { Customer } from './customer';

/**
 * Sort options of the customer list. `direction` is the natural default when the field is chosen,
 * `asc` / `desc` describe each direction for the direction toggle.
 */
export const CUSTOMER_SORTS = [
  { value: 'lastOrderAt', label: 'Last order', direction: 'desc', desc: 'Newest first', asc: 'Oldest first' },
  { value: 'totalSpentCents', label: 'Money spent', direction: 'desc', desc: 'Highest first', asc: 'Lowest first' },
  { value: 'orderCount', label: 'Orders', direction: 'desc', desc: 'Most first', asc: 'Fewest first' },
  { value: 'photoCount', label: 'Photos printed', direction: 'desc', desc: 'Most first', asc: 'Fewest first' },
  { value: 'nameSort', label: 'Name', direction: 'asc', desc: 'Z–A', asc: 'A–Z' },
] as const satisfies readonly {
  value: keyof Customer;
  label: string;
  direction: OrderByDirection;
  desc: string;
  asc: string;
}[];

/** Customer field the list is ordered by. */
export type CustomerSort = (typeof CUSTOMER_SORTS)[number]['value'];

/** Field and direction the customer list is ordered by. */
export interface CustomerOrder {
  readonly sort: CustomerSort;
  readonly direction: OrderByDirection;
}

export const customerSortOption = (sort: CustomerSort) =>
  CUSTOMER_SORTS.find((option) => option.value === sort)!;
